import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import EvipSimilarItems from './components/EvipSimilarItems';

import { TSimilarItemsClient } from 'types/TSimilarItems';

type TEvipSimilarItemsAppProps = {
  environment: any;
  eVipSimilarItems: TSimilarItemsClient[];
};

const EvipSimilarItemsApp = ({ environment, eVipSimilarItems }: TEvipSimilarItemsAppProps) => {
  if (!eVipSimilarItems?.length) {
    return null;
  }
  return (
    <EnvironmentProvider value={environment}>
      <EvipSimilarItems eVipSimilarItems={eVipSimilarItems} />
    </EnvironmentProvider>
  );
};

export default EvipSimilarItemsApp;
